const KeySearch = ({
    placeholder = "Search...",
    serverSearch,
    setSearchTerm,
    searchTerm,
    setIsKey,   
    isKey,       
    searchKeys
}) => {

    const handleSearch = () => {
        const term = (searchTerm || "").trim();
        if (!term) return;
        setIsKey(true);              
        serverSearch(term, true);   
    };

    return (
        <div className="flex items-center w-full max-w-md">
            <input
                type="search"
                placeholder={placeholder}
                value={searchTerm}
                onChange={(e) => {
                    const val = e.target.value;
                    setSearchTerm(val);
                    if (!val.trim()) {
                        setIsKey(false);
                    }
                }}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        handleSearch();
                    }
                }}
                className="w-full border px-3 py-2 text-sm rounded-l-xl outline-none"
            />

            <button
                type="button"
                onClick={handleSearch}
                className="bg-blue-600 text-white px-4 py-2 rounded-r-xl"
            >
                Search
            </button>
        </div>
    );
};

export default KeySearch;
